module.exports = __webpack_public_path__ + "img/1.e67315d8.png";